function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Layer from '@mozaic-ds/freemarker/js/modules/_layer';
import { fetchStoresAroundRendering, initStoreContextSearch } from "./components/store-context-search/store-context-search";
import { initStoreContextCard } from "./components/store-context-card/store-context-card";
import { hitEventTms } from "integration-web-core--socle/js/assets/commons/_tms.js";
import { applyTrackingAndContextCookieOnStoreSearchBlock, applyTrackingAndContextCookieOnStoreSearchBlockWithoutCoordinates, integrateHtmlToStoreSearchBlock } from "./components/store-search-result/store-search-result";
import { retrieveCookieValueByName, retrieveCustomerContextCookieValue } from "../common/cookie-finder";
export var STORE_SEARCH = 'store-search';
export var ID_SELECTOR = 'data-selectorid';
export var STORE_CARD = 'store-card';
export var STORE_LAYER_TITLE = '.mc-layer__title';
export var CONTEXTUALIZATION_LAYER = 'openStoreContextLayer';
export var CONTEXTUALIZATION_LAYER_SEARCH_MODE_EVENT = 'openStoreContextLayerInSearchMode';
export var customerContextPostcode = '';
export var customerContextCity = '';
var KL_HIDDEN_CLASS = 'kl-hidden';
var CustomerContextLayer = /*#__PURE__*/function (_lm$Composant) {
  function CustomerContextLayer(componentName) {
    var _this;
    _classCallCheck(this, CustomerContextLayer);
    _this = _callSuper(this, CustomerContextLayer, [componentName]);
    _defineProperty(_this, "isUserContextualizedWithStoreCookie", void 0);
    _defineProperty(_this, "CustomerContextLayerBlock", void 0);
    _defineProperty(_this, "storeSearchContainer", void 0);
    _defineProperty(_this, "storeCardContainer", void 0);
    _defineProperty(_this, "layer", void 0);
    _this.initCustomerContextLayerClass();
    _this.addRefreshLayerEvent();
    return _this;
  }
  _inherits(CustomerContextLayer, _lm$Composant);
  return _createClass(CustomerContextLayer, [{
    key: "initCustomerContextLayerClass",
    value: function initCustomerContextLayerClass() {
      var _this2 = this;
      this.CustomerContextLayerBlock = document.querySelector("[".concat(ID_SELECTOR, "=\"component-customer-context-layer\"]"));
      this.storeSearchContainer = this.CustomerContextLayerBlock.querySelector("[".concat(ID_SELECTOR, "=\"").concat(STORE_SEARCH, "\"]"));
      this.isUserContextualizedWithStoreCookie = this.CustomerContextLayerBlock.dataset.isusercontextualized === 'true';
      this.initLayer();
      window.addEventListener(CONTEXTUALIZATION_LAYER, function () {
        return _this2.layer.open();
      });
      window.addEventListener(CONTEXTUALIZATION_LAYER_SEARCH_MODE_EVENT, function (e) {
        return _this2.loadSearchLayer(e);
      });
      if (this.isUserContextualizedWithStoreCookie) {
        initStoreContextCard(this.CustomerContextLayerBlock);
      } else {
        this.storeSearchContainer.classList.remove(KL_HIDDEN_CLASS);
      }
      initStoreContextSearch();
    }
  }, {
    key: "onLayerOpening",
    value: function onLayerOpening() {
      var _this3 = this;
      // Timeout to wait for button_context_used cookie to be possibly set (exception for standalone)
      setTimeout(function () {
        var buttonContextUsedCookie = retrieveCookieValueByName("button_context_used");
        hitEventTms(window, 'cdl_event', JSON.stringify({
          'event_name': 'step.display',
          'event_data': {
            'feature_name': 'context_layer',
            'step_name': _this3.isUserContextualizedWithStoreCookie ? 'information content' : 'store search',
            'funnel_name': buttonContextUsedCookie || 'standalone'
          }
        }));
      }, 500);
    }
  }, {
    key: "onLayerClosing",
    value: function onLayerClosing(storeCardContainer, CustomerContextLayerTitle) {
      var _this4 = this;
      if (this.isUserContextualizedWithStoreCookie) {
        setTimeout(function () {
          _this4.storeSearchContainer.classList.add(KL_HIDDEN_CLASS);
          storeCardContainer.classList.remove(KL_HIDDEN_CLASS);
          CustomerContextLayerTitle.innerHTML = storeheader.i18n.context_layer_title;
        }, 250);
      }
    }
  }, {
    key: "initLayer",
    value: function initLayer() {
      var _this5 = this;
      this.storeCardContainer = this.CustomerContextLayerBlock.querySelector("[".concat(ID_SELECTOR, "=\"").concat(STORE_CARD, "\"]"));
      var CustomerContextLayerTitle = this.CustomerContextLayerBlock.querySelector("".concat(STORE_LAYER_TITLE));
      this.layer = new Layer({
        'classContent': 'js-store-context-layer',
        'onOpen': function onOpen() {
          return _this5.onLayerOpening();
        },
        'onClose': function onClose() {
          return _this5.onLayerClosing(_this5.storeCardContainer, CustomerContextLayerTitle);
        }
      });
    }
  }, {
    key: "loadSearchLayer",
    value: function loadSearchLayer(event) {
      var _this6 = this;
      this.openSearchLayer();
      var customerContextCookie = retrieveCustomerContextCookieValue();
      // TODO remove check of latitude and longitude when cookie will be removed if values not present
      if (customerContextCookie && customerContextCookie.latitude && customerContextCookie.longitude) {
        fetchStoresAroundRendering(customerContextCookie.latitude, customerContextCookie.longitude, event.detail).then(function (result) {
          customerContextPostcode = customerContextCookie.postcode;
          customerContextCity = customerContextCookie.city;
          integrateHtmlToStoreSearchBlock(result, _this6.storeSearchContainer);
          applyTrackingAndContextCookieOnStoreSearchBlock(_this6.storeSearchContainer, customerContextCookie.latitude, customerContextCookie.longitude);
        });
      } else {
        applyTrackingAndContextCookieOnStoreSearchBlockWithoutCoordinates(this.storeSearchContainer);
      }
    }
  }, {
    key: "openSearchLayer",
    value: function openSearchLayer() {
      this.storeCardContainer && this.storeCardContainer.classList.add(KL_HIDDEN_CLASS);
      this.storeSearchContainer && this.storeSearchContainer.classList.remove(KL_HIDDEN_CLASS);
      this.layer.open();
    }
  }, {
    key: "clearExpiredEventListeners",
    value: function clearExpiredEventListeners() {
      var _this7 = this;
      window.removeEventListener(CONTEXTUALIZATION_LAYER, function () {
        return _this7.layer.open();
      });
      window.removeEventListener(CONTEXTUALIZATION_LAYER_SEARCH_MODE_EVENT, function (e) {
        return _this7.loadSearchLayer(e);
      });
    }
  }, {
    key: "addRefreshLayerEvent",
    value: function addRefreshLayerEvent() {
      var _this8 = this;
      window.addEventListener("refreshCustomerContextLayerJs", function () {
        _this8.clearExpiredEventListeners();
        _this8.initCustomerContextLayerClass();
      });
    }
  }]);
}(lm.Composant);
lm.DOMReady(function () {
  new CustomerContextLayer('CustomerContextLayer');
});